


















import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

import Left from "@/views/Layout/Left/index.vue";
import Main from "@/views/Layout/Main/index.vue";
import Right from "@/views/Layout/Right/index.vue";

import HandlerMixin from "@/mixins/handler";

@Component({
  components: {
    Left,
    Main,
    Right,
  },
})
export default class App extends mixins(HandlerMixin) {}
